// extracted by mini-css-extract-plugin
export default {"promoCodeModal":"styles_promoCodeModal__oI5F1","applied":"styles_applied__sbBkV","appliedText":"styles_appliedText__k1sNy","appliedButton":"styles_appliedButton__fYsz0"};